import {
  getIpManagementList,
  getManagementInfo,
  updateManagementInfo,
} from "@/http/setup/ipManagement";

export default {
  namespaced: true,
  state: {
    ipListMessages: {
      pageItems: [],
    },
    infoDatasTemplates: [],
  },
  actions: {
    async updateManagementInfo(_, payload) {
      return await updateManagementInfo(payload);
    },
    async setIpManagementGroup({ commit }) {
      try {
        const data = await getIpManagementList();
        commit("IP_MANAGEMENT_LIST", data);
        return data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setManagementInfo({ commit }) {
      try {
        const data = await getManagementInfo();
        commit("SET_CLIENT_IP_INFO", data);
        return data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    IP_MANAGEMENT_LIST(state, payload) {
      state.ipListMessages = payload;
    },
    SET_CLIENT_IP_INFO(state, payload) {
      state.infoDatasTemplates = payload;
      s;
    },
  },
  getters: {
    GetIpManagementList(state) {
      return (
        state.ipListMessages &&
        state.ipListMessages.data &&
        state.ipListMessages.data.pageItems
      );
    },
    GetManagementInfo(state) {
      return (
        state.infoDatasTemplates &&
        state.infoDatasTemplates.data &&
        state.infoDatasTemplates.data.codeValueDatas
      );
    },
  },
};
